import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AssessmentService } from '../../assessments/assessment.service';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EDITOR_INLINE_EDIT, EDITOR_READONLY } from '../editor-config';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/services/loader.service';
import { toasterMessages } from '@messages/*';
import { MatMenu } from '@angular/material/menu';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { RegenerateQuestionDialogComponent } from 'src/app/components/regenerate-question-dialog/regenerate-question-dialog.component';
import { RegenerateFlowService } from 'src/app/services/regenerate-flow.service';

@Component({
  selector: 'app-oeqs-list',
  templateUrl: './oeqs-list.component.html',
  styleUrls: ['./oeqs-list.component.scss']
})

export class OeqsListComponent implements OnInit {

  @Input() oeqsInfo: any;
  @Input() showCheckboxes = false;
  @Output() removeSelectedOEQ = new EventEmitter<string>();
  @Output() selectedOEQ = new EventEmitter<any>();
  @Output() oeqScroll = new EventEmitter<string>();
  @Output() oeqCountChanged = new EventEmitter<number>();
  @Output() bulkActionDone = new EventEmitter<void>();
  @Output() addOeqToAssessmentEvent = new EventEmitter<any>();

  private subscriptions: Subscription[] = [];
  private assessmentId: string = '';
  private editAssessmentId: string = '';
  private selectedOeqUndoTimeout: any;
  errorMessage: string = '';
  genearateSuccess: boolean = false;
  displayText: string = 'Re-Generating Question...';
  undoSelectedItem: any = { message: 'Question has been selected', duration: 5 };
  selectedOption: number = -1;
  menuItem: any = null;
  setMenuItem(item: any) {
    this.menuItem = item;
  }

  // Add property to track selected questions
  hasSelectedQuestions(): boolean {
    return this.oeqsInfo?.questions?.some(q => q._selected);
  }

  editorConfig: AngularEditorConfig = EDITOR_READONLY;

  editorEditConfig = EDITOR_INLINE_EDIT;

  @ViewChild('questionEditor') questionEditor: any;
  @ViewChild('oeqMenu') oeqMenu!: MatMenu;
  @ViewChild('selectedMenu') selectedMenu!: any;

  constructor(private assessmentService: AssessmentService,
    private activatedRoute: ActivatedRoute,
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    private loaderService: LoaderService,
    public dialog: MatDialog,
    private regenerateFlow: RegenerateFlowService) {
    this.editAssessmentId = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit(): void {
    this.assessmentId = this.oeqsInfo.assessmentId || this.editAssessmentId;
  }

  undoSelectDeletedQuestion(question) {
    question.deleted = false;
  }

  removeSelectedOeQuestionCross(question): void {
    question.edit_clicked = false;
    if (question.selected) {
      return;
    }
    if (this.oeqsInfo.from === 'questionsList') {
      this.removeSelectedOEQ.emit(question._id);
      return;
    }
    question.deleted = true;
  }

  /** Add open ended question to assessment. */
  addOeqToAssessment(item: any) {
    item.selected = true;
    item.edit_clicked = false;
    item.displayText = 'Adding question...';
    const data = {
      status: 'SELECTED',
      assessmentId: this.assessmentId
    };
    this.subscriptions.push(
      this.assessmentService.selectOrUndoQuestionToAssessment(item._id, data).subscribe(
        (res) => {
          item.displayText = '';
          const serverItem = (res as any) && (res as any)._id ? { ...item, ...(res as any), sourceQuestionId: item._id } : item;
          this.selectedOeqUndoTimeout = setTimeout(() => {
            serverItem.selected = false;
            serverItem.status = 'SELECTED';
            this.selectedOEQ.emit(serverItem);
          }, this.undoSelectedItem.duration * 1000);
        },
        (err) => {
          this.errorMessage = err?.error?.errors[0]?.error || 'Something went wrong please try again!';
          item.error = true;
          setTimeout(() => {
            item.selected = false;
            item.error = false;
          }, 3000);
        }
      )
    );
  }

  /**Undo selected question. */
  undoSelectedIQuestion(item): void {
    clearTimeout(this.selectedOeqUndoTimeout);
    item.selected = true;
    item.displayText = 'The selected question is being undone...';
    const data = {
      "status": "GENERATED",
      "assessmentId": this.assessmentId
    }
    this.subscriptions.push(
      this.assessmentService.selectOrUndoQuestionToAssessment(item._id, data).subscribe((res) => {
        item.displayText = '';
        item.selected = false;
      }, (err) => {
        item.error = true;
        setTimeout(() => {
          item.selected = false;
          item.error = false;
        }, 3000);
      })
    );
  }

  /**Remove Selected question */
  removeSelectedQuestionWithOk(question) {
    question.displayText = 'Removing Question...';
    if (question.status === 'GENERATED') {
      this.dashboardService.deleteQuestion(question._id).subscribe((res) => {
        question.displayText = '';
        question.deleted = false;
        this.removeSelectedOEQ.emit(question);
      }, (err) => {
        question.error = true;
        setTimeout(() => {
          question.deleted = false;
          question.error = false;
        }, 3000);
      })
    } else {
      const data = {
        "status": "GENERATED",
        "assessmentId": this.assessmentId
      }
      this.subscriptions.push(
        this.assessmentService.selectOrUndoQuestionToAssessment(question._id, data).subscribe((res) => {
          question.displayText = '';
          question.deleted = false;
          this.removeSelectedOEQ.emit(question);
        }, (err) => {
          question.error = true;
          this.errorMessage = err?.error?.errors[0]?.error || 'Something went wrong please try again!';
          setTimeout(() => {
            question.deleted = false;
            question.error = false;
          }, 3000);
        })
      );
    }
  }

  onOeqScroll(): void {
    this.oeqScroll.emit();
  }

  onEditClick(editItem) {
    this.oeqsInfo.questions.forEach(q => q.edit_clicked = false);
    editItem.edit_clicked = true;
    editItem.temp_questionText = this.formatQuestionText(editItem.questionText);
    editItem.temp_answer = this.formatQuestionText(editItem?.answer);
    editItem._original_questionText = editItem.questionText;
    editItem._original_answer = editItem.answer;
    if (!editItem.expanded) {
      editItem.expanded = true;
    }
    this.closeMenu();
  }

  private closeMenu() {
    if (this.oeqMenu && this.oeqMenu.closed) {
      this.oeqMenu.closed.emit();
    }
  }

  focusQuestionEditor() {
    if (this.questionEditor && this.questionEditor.textArea) {
      this.questionEditor.textArea.nativeElement.focus();
    }
  }

  onPanelOpen(item) {
    item.expanded = true;
  }

  onPanelClose(item) {
    item.expanded = false;
    item.edit_clicked = false;
  }

  onEditCancelBtnClick(editedItem: any): void {
    if (editedItem?.edit_clicked) {
      editedItem.edit_clicked = false;
      editedItem.questionText = editedItem._original_questionText;
      editedItem.answer = editedItem._original_answer;
      editedItem.temp_questionText = this.formatQuestionText(editedItem.questionText);
      editedItem.temp_answer = this.formatQuestionText(editedItem.answer);
    }
  }

  onEditDone(question) {
    this.loaderService.show('Updating open ended question');
    const payload: any = {
      questionText: question?.temp_questionText?.replace(/&#10;/g, '\n'),
      answer: question?.temp_answer?.replace(/&#10;/g, '\n'),
    };
    this.subscriptions.push(
      this.dashboardService.updateQuestion(payload, question._id).subscribe((response) => {
        const selectedIndex = this.oeqsInfo?.questions?.findIndex(x => x._id === question._id);
        this.oeqsInfo.questions[selectedIndex] = response;
        question.edit_clicked = false;
        this.loaderService.hide();
        this.toastr.success(toasterMessages.questionOEQUpdated, 'Question updated', { timeOut: 2500 });
        if (this.oeqMenu && this.oeqMenu.closed) {
          this.oeqMenu.closed.emit();
        }
      }, err => {
        // Revert to original values on error
        question.questionText = question._original_questionText;
        question.answer = question._original_answer;
        question.edit_clicked = false;
        this.toastr.error(err?.error?.errors[0]?.error || 'Failed to update question.', 'Error', { timeOut: 2500 });
        this.loaderService.hide();
      })
    );
  }

  // Removed old GET-based re-generate method; dialog uses POST with optional hints

  openRegenerateDialog(question: any): void {
    if (this.oeqMenu && this.oeqMenu.closed) {
      this.oeqMenu.closed.emit();
    }
    this.subscriptions.push(
      this.regenerateFlow.ask('OPEN_ENDED', question.additionalPrompts || []).subscribe((result: any) => {
        if (!result || result === 'cancel') { return; }
        question.regenerate = true;
        this.genearateSuccess = false;
        this.displayText = 'Re-Generating Question...';
        const headers = { 'skip-loader': 'true' };
        this.dashboardService.reGenerateQuestion(question._id, headers, result.additionalPrompts || []).subscribe((response) => {
          const selectedIndex = this.oeqsInfo?.questions?.findIndex(x => x._id === question._id);
          this.displayText = 'Successfully Re-Generated Question';
          this.genearateSuccess = true;
          this.oeqsInfo.questions[selectedIndex] = response.question;
          question.regenerate = false;
          question.deleted = false;
          // transient highlight to indicate which item got regenerated
          const updated = this.oeqsInfo.questions[selectedIndex];
          if (updated) {
            updated._highlight = true;
            setTimeout(() => { updated._highlight = false; }, 4000);
          }
        }, err => {
          this.genearateSuccess = false;
          question.regenerate = false;
          this.displayText = '';
          this.toastr.error(err?.error?.errors[0]?.error, 'Error', { timeOut: 2500 });
        });
      })
    );
  }


  onSelectChange(item: any, event: any) {
    item._selected = event.checked;
  }

  onBulkDelete(): void {
    const selected = this.oeqsInfo?.questions?.filter(q => q._selected);
    if (!selected?.length) return;
    const ids = selected.map(q => q._id);
    const idSet = new Set(ids.map(String));
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: {
        danger: true,
        messageBody: `Are you sure you want to delete ${selected.length} selected question(s)? This action cannot be undone.`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.deleteMultipleQuestions(ids).subscribe({
          next: (res) => {
            const skippedSet = new Set((res.skipped || []).map(String));
            const actuallyDeleted = ids.filter(id => !skippedSet.has(String(id)));
            this.oeqsInfo.questions = this.oeqsInfo.questions.filter(q => !actuallyDeleted.includes(String(q._id)));
            // Restore skipped questions and clear their selection
            this.oeqsInfo.questions.forEach(q => {
              if (skippedSet.has(String(q._id))) {
                q._selected = false;
              }
            });
            this.oeqsInfo.totalQuestions -= (res.deletedCount || actuallyDeleted.length);
            this.oeqCountChanged.emit(this.oeqsInfo.totalQuestions);
            this.bulkActionDone.emit(); // Hide checkboxes after bulk delete
            if (res && res.message) {
              this.toastr.info(res.message, 'Bulk Delete', { timeOut: 3500 });
            } else {
              this.toastr.success('Selected questions deleted successfully!', 'Success', { timeOut: 2500 });
            }
          },
          error: (err) => {
            this.toastr.error('Failed to delete selected questions.', 'Error', { timeOut: 2500 });
          }
        });
      }
    });
  }

  onDuplicate(item: any): void {
    const payload: any = { id: item._id };
    if (this.oeqsInfo?.category === 'PREVIOUSLYGENERATED') {
      // Library copy: do not link to assessment; stays under Previously Generated
    } else if (this.assessmentId) {
      // Generated section copy: keep in Generated for this assessment
      payload.assessmentId = this.assessmentId;
      payload.status = 'GENERATED';
    }
    this.dashboardService.CopyQuestion(payload).subscribe({
      next: (res) => {
        if (res && res._id) {
          this.oeqsInfo.questions.unshift(res); // Add to top
          this.oeqsInfo.totalQuestions += 1;
          this.oeqCountChanged.emit(this.oeqsInfo.totalQuestions);
          this.toastr.success('Question copied successfully!', 'Success', { timeOut: 2500 });
          if (this.oeqMenu && this.oeqMenu.closed) {
            this.oeqMenu.closed.emit(); // Close the menu
          }
        } else {
          this.toastr.error('Failed to copy question.', 'Error', { timeOut: 2500 });
          if (this.oeqMenu && this.oeqMenu.closed) {
            this.oeqMenu.closed.emit();
          }
        }
      },
      error: (err) => {
        this.toastr.error('Failed to copy question.', 'Error', { timeOut: 2500 });
        if (this.oeqMenu && this.oeqMenu.closed) {
          this.oeqMenu.closed.emit();
        }
      }
    });
  }

  onDelete(item: any): void {
    this.removeSelectedOeQuestionCross(item);
    if (this.oeqMenu && this.oeqMenu.closed) {
      this.oeqMenu.closed.emit();
    }
  }

  confirmDeleteSelected(item) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'delete-dialog-container',
      data: {
        danger: true,
        messageBody: `Are you sure you want to delete this question? This action cannot be undone.`
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.deleteQuestion(item._id).subscribe({
          next: () => {
            this.oeqsInfo.questions = this.oeqsInfo.questions.filter(q => q._id !== item._id);
            this.oeqsInfo.totalQuestions -= 1;
            this.oeqCountChanged.emit(this.oeqsInfo.totalQuestions);
            this.toastr.success('Question deleted successfully!', 'Success', { timeOut: 2500 });
            if (this.oeqMenu && this.oeqMenu.closed) {
              this.oeqMenu.closed.emit();
            }
          },
          error: (err) => {
            const msg = err?.error?.errors?.[0]?.error || 'Failed to delete question.';
            this.toastr.error(msg, 'Delete Error', { timeOut: 3000 });
            if (this.oeqMenu && this.oeqMenu.closed) {
              this.oeqMenu.closed.emit();
            }
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  formatQuestionText(text: string): string {
    if (!text) return '';
    let formatted = text;

    // Handle escaped newlines (common in JSON data)
    formatted = formatted.replace(/\\n/g, '\n');

    // 1. Handle Code Blocks: ```code``` -> Premium Code Box
    formatted = formatted.replace(/```[a-z]*\s*([\s\S]*?)```/g, (match, p1) => {
      const code = p1.trim();
      return `<div class="code-block-premium">${code}</div>`;
    });

    // 2. Format Headers (# or ##) -> Bold
    formatted = formatted.replace(/^#+\s*(.*)$/gm, '<b>$1</b>');

    // 3. Handle Markdown bold: **text** -> <b>text</b>
    formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');

    // 4. Handle Inline Code: `code` -> <code>code</code>
    formatted = formatted.replace(/`(.*?)`/g, '<code>$1</code>');

    // 5. Handle Bullet Points: "- " or "* " at start of line -> Bullet
    formatted = formatted.replace(/^\s*[\-\*]\s+/gm, '&bull; ');

    // 6. Handle Newlines: \n -> <br>
    formatted = formatted.replace(/\n/g, '<br>');

    return formatted;
  }
}
